<!--Typeahead Starts-->
<section id="typeahead">
  <div class="row text-left">
    <div class="col-sm-12">
      <div class="content-header">Typeahead</div>
    </div>
  </div>
  <div class="row text-left" matchHeight ="card">
    <!--Basic Typeahead Starts-->
    <div class="col-md-12 col-lg-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Simple Typeahead</h4>
          <p> A typeahead example that gets values from a static <code>string[]</code></p>
        </div>
        <div class="card-content">
          <div class="card-body">
            <ul>
              <li><code>debounceTime</code> operator</li>
              <li>kicks in only if 2+ characters typed</li>
              <li>limits to 10 results</li>
            </ul>
            <div class="form-group">
              <input type="text" class="form-control mb-3" [(ngModel)]="model" [ngbTypeahead]="search" placeholder="Search for alabama" />
            </div>
            <p>Model: {{ model | json }}</p>
          </div>
        </div>
      </div>
    </div>
    <!--Basic Typeahead Ends-->

    <!--Wikipedia search Starts-->
    <div class="col-md-12 col-lg-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Wikipedia search</h4>
          <p> A typeahead example that gets values from the <code>WikipediaService</code></p>
        </div>
        <div class="card-content">
          <div class="card-body">
            <ul>
              <li>remote data retrieval</li>
              <li><code>debounceTime</code> operator</li>
              <li><code>do</code> operator</li>
              <li><code>distinctUntilChanged</code> operator</li>
              <li><code>switchMap</code> operator</li>
              <li><code>catch</code> operator to display an error message in case of connectivity issue</li>
            </ul>

            <div class="form-group" [class.has-danger]="searchFailed">
              <input type="text" class="form-control" [(ngModel)]="modelWiki" [ngbTypeahead]="searchWiki" placeholder="Search for alabama"
              />
              <span *ngIf="searching">searching...</span>
              <div class="form-control-feedback" *ngIf="searchFailed">Sorry, suggestions could not be loaded.</div>
            </div>

            <p>Model: {{ modelWiki | json }}</p>
          </div>
        </div>
      </div>
    </div>
    <!--Wikipedia search Ends-->
  </div>
  <div class="row text-left" matchHeight ="card">
    <!--Formatted results Starts-->
    <div class="col-md-12 col-lg-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Formatted results</h4>
          <p>A typeahead example that uses a formatter function for string results</p>
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="form-group">
              <input type="text" class="form-control format mb-3" [(ngModel)]="modelFormat" [ngbTypeahead]="search" [resultFormatter]="formatter"
              placeholder="Search for alabama" />
            </div>
            <p>Model: {{ modelFormat | json }}</p>
          </div>
        </div>
      </div>
    </div>
    <!--Formatted results Ends-->

    <!--Template for results Starts-->
    <div class="col-md-12 col-lg-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Template for results</h4>
          <p>A typeahead example that uses custom template for results display and uses object as a model</p>
        </div>
        <div class="card-content">
          <div class="card-body">
            <ng-template #rt let-r="result" let-t="term">
              <img [src]="'https://upload.wikimedia.org/wikipedia/commons/thumb/' + r.flag" width="16"> {{ r.name}}
            </ng-template>
            <div class="form-group">
            <input type="text" class="form-control mb-3" [(ngModel)]="modelTemp" [ngbTypeahead]="searchFlags" [resultTemplate]="rt" [inputFormatter]="formatter1"
              placeholder="Search for alabama" />
            </div>
            <p>Model: {{ modelTemp | json }}</p>
          </div>
        </div>
      </div>
    </div>
    <!--Template for results Ends-->
  </div>
</section>
<!--Typeahead Ends-->